import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  EMPTY_FORM_FIELDS,
  normalizeFormFields,
} from '../helpers/normalizeFormFields';

export const FormFieldsContext = createContext(null);

async function fetchFormFields() {
  const url = process.env.REACT_APP_API_URL + '/get-form-fields';
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: process.env.REACT_APP_API_AUTHORIZATION,
    },
  };

  const result = await fetch(url, options);
  return result.json();
}

export const FormFieldsProvider = ({ children }) => {
  const [formFields, setFormFields] = useState(EMPTY_FORM_FIELDS);
  const [loadingFormFields, setLoadingFormFields] = useState(true);
  const [formFieldsError, setFormFieldsError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadFormFields = async () => {
      setLoadingFormFields(true);
      setFormFieldsError(null);

      try {
        const result = await fetchFormFields();
        if (isMounted) {
          setFormFields(normalizeFormFields(result));
        }
      } catch (error) {
        console.error('Error fetching form fields:', error);
        if (isMounted) {
          setFormFieldsError(error);
          setFormFields(EMPTY_FORM_FIELDS);
        }
      } finally {
        if (isMounted) {
          setLoadingFormFields(false);
        }
      }
    };

    loadFormFields();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <FormFieldsContext.Provider
      value={{ formFields, loadingFormFields, formFieldsError }}
    >
      {children}
    </FormFieldsContext.Provider>
  );
};

export const useFormFields = () => {
  const context = useContext(FormFieldsContext);
  if (!context) {
    throw new Error('useFormFields must be used within a FormFieldsProvider');
  }
  return context;
};
